import PageHero from "@/components/PageHero";
import CTABand from "@/components/CTABand";
import { Reveal } from "@/components/Reveal";
import { useSEO } from "@/hooks/useSEO";
import { ICONS } from "@/lib/icons";
import { GUARANTEES } from "@/lib/site";

export default function Garansi() {
  useSEO(
    "Garansi & Kebijakan",
    "Komitmen nyata HATTORY KONVEKSI: revisi desain, transparansi proses, komunikasi responsif, dan quality control bertahap di setiap fase produksi."
  );

  return (
    <>
      <PageHero
        overline="Garansi & Kebijakan"
        titleLines={["Janji Nyata", "dari HATTORY"]}
        description="Kami menjaga kepercayaan Anda dengan komitmen yang jelas di setiap tahap kerja sama."
      />

      <div className="mx-auto max-w-7xl px-6 py-20 md:px-12 md:py-28">
        <div className="grid gap-6 md:grid-cols-2" data-testid="guarantee-grid">
          {GUARANTEES.map((g, i) => {
            const Icon = ICONS[g.icon];
            return (
              <Reveal key={g.title} delay={(i % 2) * 0.1}>
                <div className="group relative h-full overflow-hidden rounded-3xl border border-silver/30 bg-white p-9 shadow-soft transition-transform duration-300 hover:-translate-y-1 hover:shadow-lift">
                  <div className="pointer-events-none absolute -right-6 -top-8 select-none text-8xl font-black text-surface">
                    {String(i + 1).padStart(2, "0")}
                  </div>
                  <div className="relative z-10">
                    <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-navy text-white">
                      {Icon && <Icon className="h-6 w-6" />}
                    </span>
                    <h3 className="mt-6 text-2xl font-bold tracking-tight text-navy">{g.title}</h3>
                    <p className="mt-3 leading-relaxed text-charcoal/80">{g.desc}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>

      <CTABand
        title="Punya Pertanyaan tentang Kebijakan Kami?"
        buttonLabel="Tanya via WhatsApp"
        waMsg="Halo HATTORY KONVEKSI, saya ingin bertanya tentang garansi dan kebijakan Anda."
      />
    </>
  );
}
